import { render, staticRenderFns } from "./VsNewPagination.vue?vue&type=template&id=375dcfa6&"
import script from "./VsNewPagination.vue?vue&type=script&lang=js&"
export * from "./VsNewPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports